import { useQuery } from "react-query";

import {
  getLocalStorageItem,
  QUOTE_COMPARISON_DEFAULT_CRITERIA_KEY,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { QuoteComparisonItem } from "../../types/Quote";

export type QuoteComparisonDefaultCriteria = {
  primaryCriteria: keyof QuoteComparisonItem;
  selectedCriteria: (keyof QuoteComparisonItem)[];
};

export const getQuoteComparisonDefaultCriteria = (
  options: APQueryOptions = {}
) => {
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["quote-comparison-default-criteria"],
    queryFn: (): QuoteComparisonDefaultCriteria | null => {
      return (
        getLocalStorageItem<QuoteComparisonDefaultCriteria>(
          QUOTE_COMPARISON_DEFAULT_CRITERIA_KEY
        ) || null
      );
    },
    enabled: isQueryEnabled(options),
  });
};
